<template>
  <div class="body">
    <div class="banner">
      <img :src="banner" />
    </div>

    <div class="contents">
      <div class="contentslist">
        <router-link
          class="contents-li"
          tag="li"
          v-for="(mitem, index) in list"
          :key="index"
          :to="mitem.url"
        >
          <img :src="mitem.img" />
          <p class="contents-li-title">
            {{ mitem.title }}
          </p>
          <p class="contents-li-desc">
            {{ mitem.desc }}
          </p>
        </router-link>
      </div>
      <div class="contentsus">
        <div class="contentsus-left">
          <p class="contentsus-left-title">服务热线</p>
          <p class="contentsus-left-info">采购热线：400-653-7789</p>
          <p class="contentsus-left-info">直拨专线：155-2241-5492</p>
          <p class="contentsus-left-info">服务邮箱：public@atomrobot.com</p>
          <p class="contentsus-left-lable">
            热线客服工作时间：周一至周六8:30-17:30
          </p>
        </div>
        <div class="contentsus-right">
          <img :src="helpimg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banner: "/static/help/banner.png",
      helpimg: "/static/help/help.png",
      list: [
        {
          title: "帮助中心",
          desc: "常见问题解答(FAQ),帮助您更好的获取信息",
          img: "/static/help/fqa.png",
          url: "/help/fqa"
        },
        {
          title: "我要采购",
          desc: "在线采购咨询，我们专家将与您联系",
          img: "/static/help/purchase.png",
          url: "/help/purchase"
        },
        {
          title: "供应商合作",
          desc: "成为MOVIBOT供应商",
          img: "/static/help/cooperation.png",
          url: "/help/cooperation"
        }
      ]
    };
  },
  metaInfo() {
    return {
      title: "Movibot官网_工业机器人上下游供应链",
      meta: [
        {
          name: "keywords",
          content:
            "工业机器人_工业机器人上下游供应链_工业机器人品牌_工业自动化设备_行业解决方案"
        },
        {
          name: "description",
          content:
            "Movibot汇聚中国工业机器人上下游供应链优质工业机器人品牌,为工业机器人,智能家庭及商业应用,仓储物流,食品行业,医药行业,汽车行业,机械设备制造,电子行业提供工业自动化设备和行业解决方案"
        }
      ]
    };
  }
};
</script>

<style scoped>
.body {
  background-color: #f3f5f7;
}
.contents {
  padding-bottom: 45px;
}
.banner img {
  width: 100%;
}
.contentslist {
  display: flex;
  justify-content: space-between;
  margin-top: 45px;
  margin-bottom: 45px;
}
.contentsus {
  overflow: hidden;
  background-color: #fff;
  border-radius: 10px;
}
.contentsus .contentsus-left {
  width: 615px;
  height: 330px;
  float: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 40px;
}
.contentsus .contentsus-right {
  width: 545px;
  height: 330px;
  float: left;
  border-radius: 10px;
  overflow: hidden;
}
.contentsus .contentsus-right img {
  width: 100%;
  height: 100%;
}
.contents-li {
  background-color: #fff;
  cursor: pointer;
  border-radius: 3px;
  overflow: hidden;
}
.contents-li:hover {
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
}
.contents-li-title {
  font-size: 16px;
  color: #333333;
  text-indent: 24px;
  margin-top: 18px;
  margin-bottom: 15px;
}
.contents-li-desc {
  font-size: 14px;
  color: #666666;
  text-indent: 24px;
  margin-bottom: 40px;
}
.contentsus-left-title {
  font-size: 35px;
  color: #333333;
  margin-bottom: 20px;
}
.contentsus-left-info {
  font-size: 24px;
  color: #666666;
  line-height: 1.8;
}
.contentsus-left-lable {
  margin-top: 40px;
  font-size: 18px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/views/help/index.vue